import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import AddIcon from '@material-ui/icons/Add';
import {useSelector, useDispatch} from 'react-redux'
import {isEmpty, isNull} from 'lodash'
import CheckIcon from '@material-ui/icons/Check';
import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined';
import {getBoardAktivitet,updateBoard} from 'actions'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'

const useStyles = makeStyles({
  cardAvatar2: {
    height: 35,
    width: 35,
    fontSize: 15,
    marginRight: 4,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  cardSideOptionsButton: {
    textTransform: 'none'
  },
  barBtn: {

    textTransform: 'none',
    color: '#fff',
    backgroundColor: 'hsl(183deg 49% 46%)'
},
});

export default function AddSubTaskMedarr({collaborators, complete}) {
  const dispatch = useDispatch()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [medarbetare, setMedarbetare] = React.useState(collaborators);
  const classes = useStyles();
  const Userlista = useSelector(state => state.accountsData.Userlista)
  const KontakterList = useSelector(state => state.accountsData.KontakterList)
  const Userid = useSelector(state => state.auth.authUser.user_id)
  const Afid = useSelector(state => state.auth.authUser.user_Afid)
  const authUser = useSelector(state => state.auth.authUser)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleSelect = (user) => {
    let medarr = collaborators.concat([{...user}])
    setMedarbetare(medarr)
    
    complete(medarr)
    // handleClose()
  }
  const handleDeselect = (user) => {
    let medarr = collaborators.filter(u => u.id !== user.id)
    setMedarbetare(medarr)
    
    complete(medarr)
  }

  const handleClose = () => {
    setAnchorEl(null);
  };
  React.useEffect(() => {
    setMedarbetare(collaborators)
  }, [collaborators])

  return (
    <>
      <IconButton onClick={handleClick} >
        <PersonAddOutlinedIcon />
      </IconButton>
      {/* <Button 
        onClick={handleClick}
        // component="span"
        // disabled={!isAdmin()}
        size="small" 
        className={'shadow-none mr-2 ml-2 ' + classes.barBtn}
        variant="contained"
        startIcon={<PersonAddOutlinedIcon/>}
          ><IntlMessages id="E-singing.invite" /></Button> */}
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
         {/* {            
          !isEmpty(Userlista.filter(item=>{return !isEmpty(item.UserEmail)}))?
          parseInt(authUser.user_role) > 1?
          parseInt(authUser.user_OfficeId) > 0?
          parseInt(MyOfficeType) ===2?
          Userlista.filter(item=>{return !isEmpty(item.UserEmail)})
          .filter(item=>{return item.OfficeId ===authUser.user_OfficeId })
          .map((option) => (
            isUndefined(isFrom)?
            <MenuItem onClick={() => handleSelect(option)}>
              {option.FirstName} {option.LastName}
            </MenuItem>
            :
            <MenuItem onClick={() => handleSelect(option)}>
              {option.FirstName} {option.LastName}
            </MenuItem>
          ))
          :
          Userlista
          .filter(item=>{return !isEmpty(item.UserEmail)}).map((option) => (
            isUndefined(isFrom)?
            <MenuItem onClick={() => handleSelect(option)}>
              {option.FirstName} {option.LastName}
            </MenuItem>
             :
             <MenuItem onClick={() => handleSelect(option)}>
               {option.FirstName} {option.LastName}
             </MenuItem>
          ))
          :
          Userlista
          .filter(item=>{return !isEmpty(item.UserEmail)}).map((option) => (
            isUndefined(isFrom)?
            <MenuItem onClick={() => handleSelect(option)}>
              {option.FirstName} {option.LastName}
            </MenuItem>
             :
             <MenuItem onClick={() => handleSelect(option)}>
               {option.FirstName} {option.LastName}
             </MenuItem>
          ))
          :
          Userlista.filter(item=>{return !isEmpty(item.UserEmail)}).map((option) => (
            isUndefined(isFrom)?
            <MenuItem onClick={() => handleSelect(option)}>
              {option.FirstName} {option.LastName}
            </MenuItem>
            :
            <MenuItem onClick={() => handleSelect(option)}>
              {option.FirstName} {option.LastName}
            </MenuItem>            
          )):""}
            {
              !isUndefined(isFrom)?
              isEmpty(KontakterList)?"":
              KontakterList.filter(item=>{return !isEmpty(item.Email)}).map((option) => (
                <MenuItem onClick={() => handleSelect(option)}>
                  {option.fname} {option.lname}
                </MenuItem>  
              ))
              :""
            } */}
        {
          isEmpty(Userlista) ? "" :
          Userlista.map(u => {
            console.log(u)
            if(medarbetare.find(user => user.id === u.id)) {
              return <MenuItem 
              // disabled
              onClick={() => handleDeselect(u)}
              >{u.FirstName + " " +u.LastName} <CheckIcon/></MenuItem>
            }
            else {
              return(
                <MenuItem 
                onClick={() => handleSelect(u)}
                >{u.FirstName + " " +u.LastName}</MenuItem>
              )
            }
          })
        }
        
      </Menu>
    </>
  );
}
